/**
 * Mar 3, 2026 · Tiny error boundary — used to isolate the iOS install
 * banner (and any future PWA chrome) so a runtime error there can't
 * take down the whole app. Renders nothing on error.
 */
import React from "react";

export default class SafeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err) { try { console.warn("[SafeBoundary]", err?.message || err); } catch (_e) {} }
  render() { return this.state.hasError ? null : this.props.children; }
}
